import React from 'react';
import { useEffect, useRef, useState } from 'react'
import {
  SActionBtn,
  SBack,
  SLowcodeList,
  STableActions,
  SMessage,
} from 'shj-components'
import { Switch, Input, Select, message } from 'antd';
import {
  getContractTemplateList,
  deleteContractTemplate,
  changeContractTemplateStatus,
} from '@/services/goods.ts';
import ContentModal from './components/contentModal';
import ExtraModal from './components/extraModal';
import { config } from './config/index.tsx'
import styles from './index.module.less'

export default function ContractTemplate ()  {
  const listRef = useRef()
  const [openPrintModal, setOpenPrintModal] = useState(false)
  const [openDictionaryModal, setOpenDictionaryModal] = useState(false)
  const [editId, setEditId] = useState('');

  useEffect(() => {

  }, []);

  const fetchList = async values => {
    try {
      const res: any = await getContractTemplateList({ ...values, pageId: values?.current, nameLike: values?.query?.name });
      if (!res?.list) {
        message.error('查询列表失败');
        return;
      }
      return {
        records: res?.list,
        total: res?.count,
      };
    } catch (err) {
      message.error('查询列表失败');
    }
  }

  const onAdd = () => {
    setEditId('');
    setOpenPrintModal(true);
  }

  const onEdit = (record: any = {}) => {
    setEditId(record?.id);
    setOpenPrintModal(true);
  }

  const setExtraData = (record: any = {}) => {
    setEditId(record?.id);
    setOpenDictionaryModal(true);
  }

  const onDelete = async (record: any) => {
    SMessage.delete({
      onOk: async () => {
        try {
          const res: any = await deleteContractTemplate(record.id)
          if (res.errorCode === 0) {
            message.success('删除成功');
            (listRef as any)?.current?.reload();
          } else {
            message.error('删除失败');
          }
        } catch (err) {
          console.log(err)
        }
      },
      onCancel: () => {
        message.warning('取消删除');
      },
    });
  }

  const changeStatus = async (enable: boolean, record: any) => {
    try {
      const res: any = await changeContractTemplateStatus({
        id: record.id,
        enable,
      });
      if (res?.errorCode === 0) {
        message.success('修改状态成功');
        (listRef as any)?.current?.reload();
      }
    } catch (err) {
      console.log(err)
    }
  }

  // 表格配置
  const extensions = {
    request: { fetchList },
    events: { onAdd, onEdit },
    status: {
      // selectedDisabled: ({ selectedRowKeys }: any) => !selectedRowKeys.length,
      // radioDisabled: ({ selectedRowKeys }: any) => selectedRowKeys.length !== 1,
      // exportLoading: state.exportLoading,
    },
    customRender: {
      statusRender(value, record) {
        return (
          <div>
            <Switch checkedChildren="启用" unCheckedChildren="停用" checked={value} onChange={(enable) => changeStatus(enable, record)} />
          </div>
        )
      },
      actionRender(_, record: Record<string, any>) {
        return (
          <STableActions>
            <SActionBtn onClick={() => onEdit(record)}>
              编辑
            </SActionBtn>
            <SActionBtn style={{ color: 'red' }} onClick={() => onDelete(record)}>
              删除
            </SActionBtn>
            <SActionBtn onClick={() => setExtraData(record)}>
              扩展字段配置
            </SActionBtn>
          </STableActions>
        )
      },
    },
  }

  return (
    <div className={styles.settlementQuotaConfig}>
      {/* 右侧数据表格 */}
      <div className={styles.rightTable}>
        <SBack title="合同模板管理"></SBack>
        <SLowcodeList ref={listRef} searchMode="group" config={config} {...extensions} />
      </div>
      { openPrintModal && <ContentModal list={listRef} editId={editId} open={openPrintModal} onClose={() => setOpenPrintModal(false)} /> }
      { openDictionaryModal && <ExtraModal
        editId={editId}
        open={openDictionaryModal}
        onClose={() => setOpenDictionaryModal(false)}
      /> }
    </div>
  )
}